// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2XtXx","notes":"Notes_notes__FTqqU"};